module.exports = __webpack_public_path__ + "img/librarybg4.84ce98f5.png";